import { render, staticRenderFns } from "./bubble.vue?vue&type=template&id=75df982e&scoped=true"
import script from "./bubble.vue?vue&type=script&lang=js"
export * from "./bubble.vue?vue&type=script&lang=js"
import style0 from "./bubble.vue?vue&type=style&index=0&id=75df982e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75df982e",
  null
  
)

export default component.exports